export enum MissingDataActions {
  ThrowError = 'ThrowError',
  AssumeMet = 'AssumeMet',
  AssumeNotMet = 'AssumeNotMet',
}
